<template>
  <div class="app" id="app">
    <Header></Header>
    <router-view />
    <SliderService></SliderService>
    <Footer></Footer>
    <div
      v-if="installerModalOpen === true"
      class="install-now-wrapper"
      @click="() => installPrompt()"
    >
      <div class="install-now">
        <p>
          Laden Sie sich den
          <strong>Profilberater</strong> direkt auf Ihr Smartphone oder Tablet.
        </p>
        <ol>
          <li>
            Öffnen Sie in Ihrem Browser die
            <strong>Teilen Funktion</strong> (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="icon"
            >
              <g>
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                <polyline points="16 6 12 2 8 6" />
                <line x1="12" y1="2" x2="12" y2="15" />
              </g>
            </svg>
            ) und wählen Sie „
            <b>Zum Home-Bildschirm</b>” aus.
          </li>
          <li>
            Klicken Sie auf
            <strong>Hinzufügen</strong> um die Verlinkung auf Ihrem Homescreen zu speichern.
          </li>
        </ol>
        <p>
          Dort kann der
          <strong>Profilberater</strong> auch offline genutzt werden.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import SliderService from '@/components/SliderService.vue';
import Footer from '@/components/Footer.vue';

import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  name: 'App',
  components: {
    Header,
    SliderService,
    Footer,
  },
  data() {
    return {
      showInstaller: false,
      isIOS: false,
      installerModalOpen: false,
    };
  },
  methods: {
    installPrompt() {
      if (this.isIOS) {
        this.installerModalOpen = !this.installerModalOpen;
      }
      if (this.deferredPrompt) {
        this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            this.showInstaller = false;
          } else {
            this.showInstaller = true;
          }
        });
      }
    },
  },
  mounted() {
    this.isIOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (this.isIOS) {
      this.showInstaller = true;
    }

    document.body.addEventListener('click', (e) => {
      this.installerModalOpen = false;
    });

    this.showInstaller = true;
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.showInstaller = true;
      this.deferredPrompt = e;
    });
  },
};
</script>

<style lang="scss">
@import '@/scss/styles.scss';
.install-now-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 990;
}
.install-now {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 80%;
  transform: translate3d(-50%, -50%, 0);
  background: $color-white;
  padding: 2rem;
  z-index: 999;

  ol {
    list-style: none;
    counter-reset: my-awesome-counter;
    li {
      margin: 0 0 1rem 1.5rem;
      position: relative;
      counter-increment: my-awesome-counter;

      &:before {
        content: counter(my-awesome-counter);
        left: -1.5rem;
        position: absolute;
        color: $color-white;
        width: 1rem;
        height: 1rem;
        background: $color-primary;
        font-size: 0.75rem;
        line-height: 1rem;
        text-align: center;
      }
    }
  }

  strong {
    color: $color-primary;
    font-weight: bold;
  }

  b {
    font-weight: bold;
  }
}
</style>
